import { EndpointDefinition } from "../_sdk/types/common";

export const apiName = "ai";

export const endpoints: { [key: string]: EndpointDefinition } = {
    generateSlide: {
        route: "/slides/generate",
        method: "POST",
    },
    generateSlidePublic: {
        route: "/slides/generate-public",
        method: "POST",
    },
    generatePresentationOutline: {
        route: "/presentations/generate-outline",
        method: "POST",
    },
    generateWordCloud: {
        route: "/wordcloud/generate",
        method: "POST",
    },
    rewriteText: {
        route: "/text/rewrite",
        method: "POST",
    },
    generateSlideNotes: {
        route: "/slides/generate-notes",
        method: "POST",
    },
    analyzeWebpage: {
        route: "/analyze/webpage",
        method: "POST",
    },
    generateImages: {
        route: "/images/generate",
        method: "POST",
    },
    translateText: {
        route: "/text/translate",
        method: "POST",
    },
    translateSlide: {
        route: "/slides/translate",
        method: "POST",
    },
    translatePresentation: {
        route: "/presentations/translate",
        method: "POST",
    },
    getCreditsBalance: {
        route: "/credits/balance",
        method: "GET",
    }
};
